import React, { Component, createClass, PropTypes } from 'react';
import { Column, Table, AutoSizer } from "react-virtualized";
import ReactTooltip from 'react-tooltip';
import { Button } from 'muicss/react';
import ReactDOM from 'react-dom'
import DOM from 'react-dom-factories';

import {
    columns,
    selectColumnId,
    ingredientsSearchTabs,
    batchRecipesTabColumns,
    previousUsedTabColumns,
    customIngredientsTabColumns,
    noDataMessage,
    noDataMessageProductCatalog,
    noListsMessage,
} from "constants/ingredientsSearch";
import SyscoBrandImage from 'assets/img/icon-syscoleaf.png';
import { handleImageError } from 'components/IngredientsSearch/ingredientsSearchHelper';

let RenderInBody = createClass({
    componentDidMount() {
        this.popup = document.createElement("div");
        document.body.appendChild(this.popup);
        this._renderLayer();
    },

    componentDidUpdate() {
        this._renderLayer();
    },

    componentWillUnmount() {
        ReactDOM.unmountComponentAtNode(this.popup);
        document.body.removeChild(this.popup);
    },

    _renderLayer() {
        ReactDOM.render(this.props.children, this.popup);
    },

    render() {
        return DOM.div();
    }
});
class IngredientTable extends Component {

    componentDidUpdate(prevProps) {
        const { focusOnRow: prevFocusedRow } = prevProps;
        const { focusOnRow, resetReposition } = this.props;
        if (focusOnRow !== null && focusOnRow !== prevFocusedRow) {
            resetReposition();
        }
    }

    handleClick = (rowData) => {
        const { onSelect } = this.props;
        onSelect(rowData);
    }

    /**
     * checks for relevant column list for each tab
     * @param {*} selectedTab
     */
    getTableColumns = (selectedTab) => {
        switch (selectedTab) {
            case ingredientsSearchTabs.BATCH_RECIPES_TAB.key:
                return batchRecipesTabColumns;
            case ingredientsSearchTabs.PREVIOUSLY_USED_TAB.key:
                return previousUsedTabColumns;
            case ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key:
                return customIngredientsTabColumns;
            default:
                return columns;
        }
    }

    /**
     * Renders name
     * @param {*} cellData
     * @param {*} rowData
     */
    renderName = (cellData, rowData) => {
        const { selectedTab } = this.props;
        const { image, key } = rowData;
        return (
            <div className={'item-with-image'} >
                {
                    selectedTab !== ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key ?
                        <div className={'item-image'}>
                            <img
                                src={image}
                                onError={handleImageError}
                            />
                        </div> : null
                }

                <div className={'item-name'} data-tip data-for={`Name-${key}`}>{cellData}</div>
                <RenderInBody>
                    <ReactTooltip id={`Name-${key}`} type='light' effect={'solid'}>
                        <div>{cellData}</div>
                    </ReactTooltip>
                </RenderInBody>
            </div>
        );
    };

    renderUsedIn = (rowData) => {
        const { timesUsed, usedInRecipes } = rowData;
        return timesUsed ?
            <div className='used-in'>
                <div className={'item-name interative-element'} data-tip data-for={`UsedIn-${rowData.key}`}>{timesUsed > 1 ? `${timesUsed} recipes` : `${timesUsed} recipe`}</div>
                <RenderInBody>
                    <ReactTooltip id={`UsedIn-${rowData.key}`} type='light' effect={'solid'}>
                    {
                        usedInRecipes.map((recipe) => {
                            const recipeId = recipe.recipeId;
                            return (
                                <div className='used-in-items' key={recipeId}>
                                    <div className='recipe-name'>
                                        {recipe.name}
                                    </div>
                                </div>
                            );
                        })
                    }
                    </ReactTooltip>
                </RenderInBody>
            </div> : <div>--</div>
    }

    handleDisabled(rowData, ingredient) {
        if (!rowData || !ingredient) {
          return false;
        }
        let supc = ingredient.editableIngredientReplacementItem.supc
          ? ingredient.editableIngredientReplacementItem.supc.split("_")[1]
          : "";
        let ingredientBrand =
          ingredient.editableIngredientReplacementItem.ingredientBrand;
        return rowData.supc
          ? rowData.supc === supc
          : rowData.name ===
              ingredient.editableIngredientReplacementItem.ingredientName &&
              (!ingredientBrand || rowData.brand === ingredientBrand);
      }
    /**
     * Render select button
     * @param {*} rowData
     */
    renderSelectButton = ({ rowData }) => {
        const { isIngredientReplacement, selectedKey, selectedTab, ingredientReplacement, isFromNotificationCenter } = this.props;
        const buttonClass = (!isIngredientReplacement ? 'mui-btn mui-btn--success flex no-margin' :
            (selectedKey === selectedTab + rowData.id + rowData.product.supc ? 'mui-btn--success' : 'mui-btn--secondary no-margin'));

        const isDisabled = isFromNotificationCenter ? false : this.handleDisabled(rowData, ingredientReplacement);

        return (
            <Button
                className={buttonClass}
                size='small'
                onClick={() => this.handleClick(rowData)}
                disabled={isDisabled}
            >
                Select
            </Button>
        )
    }

    renderBrand = (cellData, rowData) => {
        return rowData.isSyscoBrand ? (
            <div className={ 'item-brand' }>{ cellData }
                <img src={ SyscoBrandImage } data-tip data-for={`Brand-${rowData.key}`}/>
                <RenderInBody>
                    <ReactTooltip id={`Brand-${rowData.key}`} type='light' effect={'solid'}>
                        <div>Sysco Brand</div>
                    </ReactTooltip>
                </RenderInBody>
            </div>
        ) : cellData;
    };

    generateNoDataMessage = () => {
        const { showNoListsMsg, search, selectedTab } = this.props;

        if (!search.keyword) {
            if (selectedTab === ingredientsSearchTabs.FULL_PRODUCT_CATALOG_TAB.key) {
                return noDataMessageProductCatalog;
            } else if (selectedTab === ingredientsSearchTabs.ITEM_LISTS_TAB.key && showNoListsMsg) {
                return noListsMessage;
            }
        }

        return noDataMessage;
    };

    render() {
        const {
            data,
            onHeaderClick,
            sortColumn,
            sortDirection,
            focusOnRow,
            selectedTab,
        } = this.props;

        const tableColumns = this.getTableColumns(selectedTab);
        return (
            <AutoSizer>
                {({ width, height }) =>
                    <Table
                        width={width}
                        height={height - 10}
                        headerHeight={32}
                        rowHeight={55}
                        disableHeader={data && data.length ? false : true}
                        noRowsRenderer={() =>
                            <div className={'no-data-available'}>
                                { this.generateNoDataMessage() }
                            </div>
                        }
                        scrollToIndex={focusOnRow}
                        rowCount={data.length}
                        rowGetter={({ index }) => data[index]}
                        sortBy={sortColumn}
                        sortDirection={sortDirection}
                        onHeaderClick={onHeaderClick}
                    >
                        {tableColumns.map(column =>
                            <Column
                                label={column.header}
                                dataKey={column.key}
                                key={column.key}
                                width={column.maxWidth || 100}
                                cellRenderer={({ cellData, rowData }) => {
                                    switch (column.key) {
                                        case 'name':
                                            return this.renderName(cellData, rowData);
                                        case 'brand':
                                            return this.renderBrand(cellData, rowData);
                                        case 'usedInRecipes':
                                            return this.renderUsedIn(rowData);
                                        default:
                                            return cellData;
                                    }
                                }}
                            />
                        )}
                        <Column
                            width={100}
                            disableSort={true}
                            dataKey={selectColumnId}
                            key={selectColumnId}
                            cellRenderer={this.renderSelectButton}
                        />
                    </Table>
                }
            </AutoSizer>
        )
    }
}

IngredientTable.propTypes = {
    selectedTab: PropTypes.string,
    search: PropTypes.object,
    data: PropTypes.array,
    onHeaderClick: PropTypes.func,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    focusOnRow: PropTypes.number,
    onSelect: PropTypes.func,
    resetReposition: PropTypes.func,
    showNoListsMsg: PropTypes.bool,
    isIngredientReplacement: PropTypes.bool,
    selectedKey: PropTypes.string,
    isFromNotificationCenter: PropTypes.bool,
    ingredientReplacement: PropTypes.object,
};

export default IngredientTable;
